import { enumValueToText } from '~/app/utils/enumUtils'
import {
  BusGrade,
  BusTicketType,
  defBusGrade,
  defBusTicketType,
  defBusUnavailableReason,
} from '~/app/constants'
import { identity, join, not, reject } from 'ramda'
import { CartItemOptionUnavailableReason } from '~/__generated__/__types__'

export const busTicketText = enumValueToText(BusTicketType, defBusTicketType)
export const busGradeText = enumValueToText(BusGrade, defBusGrade)
export const busUnavailableReasonText = enumValueToText(
  CartItemOptionUnavailableReason,
  defBusUnavailableReason
)

export const removeFalsyAndJoin = (arr: any[]) => {
  const filteredArr = reject(v => not(identity(v)), arr)
  return join(', ', filteredArr)
}
